import SessionManager from "./sessionManager";

export const isStudentRole = (user) => String(user?.role_name || '').trim().toLowerCase() === 'student'

// True when the logged in user has the Student role
const isStudent = () => {
    try {
        return isStudentRole(JSON.parse(SessionManager.getCookie("user") || "{}"))
    } catch (error) {
        return false
    }
}

export default isStudent;
